import React from 'react';
import { Box, VStack, Flex, Icon, Text, Divider, useColorModeValue } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navPrincipais, navSecundarios, ativo, NavItem } from './navItems';

export const LARGURA_SIDEBAR = '84px';

const ItemLateral: React.FC<{ item: NavItem; selecionado: boolean; onClick: () => void }> = ({ item, selecionado, onClick }) => {
  const cor = useColorModeValue(selecionado ? 'teal.700' : 'gray.600', selecionado ? 'teal.200' : 'gray.300');
  const bgSel = useColorModeValue('teal.50', 'whiteAlpha.100');
  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      aria-label={item.label}
      aria-current={selecionado ? 'page' : undefined}
      direction="column"
      align="center"
      gap={1}
      w="72px"
      py={2}
      borderRadius="lg"
      color={cor}
      bg={selecionado ? bgSel : 'transparent'}
      _hover={{ bg: bgSel }}
    >
      <Icon as={item.icon as any} boxSize={5} />
      <Text fontSize="10px" fontWeight={selecionado ? 700 : 500} lineHeight="1.1" textAlign="center">
        {item.label}
      </Text>
    </Flex>
  );
};

const SidebarNav: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const bg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      as="nav"
      position="fixed"
      left={0}
      top={0}
      h="100vh"
      w={LARGURA_SIDEBAR}
      bg={bg}
      borderRightWidth="1px"
      borderColor={border}
      display={{ base: 'none', md: 'flex' }}
      flexDirection="column"
      alignItems="center"
      py={4}
      zIndex="sticky"
      overflowY="auto"
    >
      <VStack spacing={1}>
        {navPrincipais.map(item => (
          <ItemLateral key={item.path} item={item} selecionado={ativo(item, pathname)} onClick={() => navigate(item.path)} />
        ))}
        <Divider my={2} w="48px" />
        {navSecundarios.map(item => (
          <ItemLateral key={item.path} item={item} selecionado={ativo(item, pathname)} onClick={() => navigate(item.path)} />
        ))}
      </VStack>
    </Box>
  );
};

export default SidebarNav;
